import { render, staticRenderFns } from "./BackgroundWithOverlayExample.vue?vue&type=template&id=bdcabbce&scoped=true"
import script from "./BackgroundWithOverlayExample.vue?vue&type=script&lang=js"
export * from "./BackgroundWithOverlayExample.vue?vue&type=script&lang=js"
import style0 from "./BackgroundWithOverlayExample.vue?vue&type=style&index=0&id=bdcabbce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcabbce",
  null
  
)

export default component.exports